// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Slot from 'shared/editor/Slot';
import useLazyLoad from 'shared/hooks/useLazyLoad';
import type { $Slot } from 'shared/templates/types';
import SlideRightFadeIn from 'shared/transitions/SlideRightFadeIn';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type TemplateSettings = {
  page_title: string
}

type Props = {
  classes: Object,
  slots: $Slot[],
  templateSettings: TemplateSettings,
  widgetPresets: [],
  path: string
}

const VideoPlayerPage = (props: Props) => {
  const {
    classes: c, slots, templateSettings, widgetPresets, path
  } = props;
  const { ref, isIntersectingElement } = useLazyLoad();

  return (
    <div
      className={c.container}
      ref={ref}
    >
      <div className={c.menu}>
        <Slot id="menu-bar" slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
      <div className={c.content}>
        <div className={c.centeredContent}>
          <SlideRightFadeIn show={isIntersectingElement}>
            <div className={c.pageTitle}>{templateSettings.page_title}</div>
          </SlideRightFadeIn>
          <Slot id="content" slots={slots} widgetPresets={widgetPresets} path={path} />
        </div>
      </div>
      <footer id="footer" className={c.footer}>
        <Slot id="footer" slots={slots} widgetPresets={widgetPresets} path={path} />
      </footer>
    </div>
  );
};

const styles = {
  menu: {
    width: '100%',
    position: 'relative',
    zIndex: '10'
  },
  content: {
    width: '100%',
    background: 'white',
    position: 'relative'
  },
  pageTitle: {
    fontSize: '40px',
    fontWeight: '300',
    letterSpacing: '1px',
    lineHeight: '1.2em',
    fontFamily: FONT_FAMILY_ROBOTO,
    marginBottom: '72px',
    '@media(max-width: 960px)': {
      fontSize: '35px'
    }
  },
  centeredContent: {
    width: '100%',
    maxWidth: '1596px',
    padding: '130px 16.7% 180px',
    margin: 'auto',
    '@media(max-width: 960px)': {
      padding: '130px 36px 72px'
    }
  },
  footer: {
    width: '100%'
  },
  border: {
    '@media(max-width: 960px)': {
      width: '100%'
    }
  }
};

export default withThemeProvider(injectSheet(styles)(VideoPlayerPage));
